import styled, { css } from "styled-components"
import { Paragraph } from "@components/Typography"
import { FeedbackType } from "../"
import { breakpoints } from "@config/theme"

export const Label = styled.label`
  display: inline-block;
  color: ${(p) => p.theme.colors.text.dark};
  width: 150px;
  font-size: 1rem;
  margin: 0;
  a {
    color: inherit;
  }
`

export const SubLabel = styled(Paragraph)`
  font-size: 0.75rem;
  color: ${(p) => p.theme.colors.text.light};
  margin: 2px 0 0;
`

export const LabelWrapper = styled.div<{ feedbackType?: FeedbackType }>`
  display: flex;

  label,
  p {
    ${(p) =>
      p.feedbackType === "error" &&
      css`
        color: ${p.theme.colors.red.icon};
      `};
  }
  @media (max-width: ${breakpoints.medium}) {
    margin-bottom: 0.5rem;
  }
`
